export default __webpack_public_path__ + "static/media/02_White Noise - 16s sample.f88bad01.mp3";